export function notify(message, kind) {
  const text = String(message || 'Something went wrong. Please try again.')
  const severity = kind || (/error|fail|cannot|incorrect|invalid|required|please enter|could not/i.test(text) ? 'error' :
    /saved|updated|approved|deleted|verified|complete|recorded|repaid|settled|added|created/i.test(text) ? 'success' : 'info')
  window.dispatchEvent(new CustomEvent('app-feedback', { detail: { message: text, kind: severity } }))
}

export function confirmBottom(message) {
  return new Promise(resolve => window.dispatchEvent(new CustomEvent('app-confirm', {
    detail: { message: String(message), resolve }
  })))
}

export async function checkedFetch(url, options) {
  const response = await fetch(url, options)
  let data = null
  try { data = await response.clone().json() } catch { /* Some successful endpoints return no JSON. */ }
  if (!response.ok || data?.success === false || data?.status === 'error') {
    throw new Error(data?.error || data?.message || 'Could not save the change. Please try again.')
  }
  return response
}
